export default function TimerRing({ timeLeft, formatTime, totalSeconds = 3600 }) {
  if (timeLeft === null) return null;

  const danger = timeLeft <= 60 * 5;
  const warn = timeLeft > 60 * 5 && timeLeft <= 10 * 60;
  const pct = Math.max(0, Math.min(1, timeLeft / totalSeconds));

  // Anneau : r=16, circonférence = 2π×16 ≈ 100.53
  const R = 16;
  const CIRC = 2 * Math.PI * R; // 100.53
  // strokeDashoffset = CIRC × (1 - pct) : 0 = plein, CIRC = vide
  const offset = CIRC * (1 - pct);

  const strokeColor = danger ? "#ef4444" : warn ? "#f59e0b" : "#818cf8";
  const trackColor = danger ? "rgba(239,68,68,.12)" : warn ? "rgba(245,158,11,.12)" : "rgba(99,102,241,.12)";
  const glowColor = danger ? "rgba(239,68,68,.7)" : warn ? "rgba(245,158,11,.6)" : "rgba(99,102,241,.55)";
  const innerLabel = danger ? "URG" : warn ? "WRN" : "OK";
  const innerColor = danger ? "rgba(239,68,68,.8)" : warn ? "rgba(245,158,11,.8)" : "rgba(99,102,241,.75)";
  const valClass = danger ? "hud-timer-val" : warn ? "hud-timer-val hud-timer-val-warn" : "hud-timer-val hud-timer-val-ok";

  return (
    <div className="hud-sec" style={{ borderBottom: "1px solid rgba(255,255,255,.04)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div className={danger ? "hud-timer-svg" : ""} style={{ flexShrink: 0 }}>
          <svg width="52" height="52" viewBox="0 0 40 40">
            {/* Track */}
            <circle cx="20" cy="20" r={R} fill="none" stroke={trackColor} strokeWidth="3.5" />
            {/* Progress — commence à 12h (rotate -90) */}
            <circle cx="20" cy="20" r={R} fill="none"
              stroke={strokeColor} strokeWidth="3.5"
              strokeDasharray={CIRC} strokeDashoffset={offset}
              strokeLinecap="round"
              transform="rotate(-90 20 20)"
              style={{ filter: `drop-shadow(0 0 4px ${glowColor})`, transition: "stroke-dashoffset .5s ease" }}
            />
            {/* Label centre */}
            <text x="20" y="24" textAnchor="middle" fill={innerColor}
              fontSize="7" fontFamily="ui-monospace,'SF Mono',monospace" fontWeight="800" letterSpacing="0.5">
              {innerLabel}
            </text>
          </svg>
        </div>
        <div style={{ flex: 1 }}>
          <div className="hud-timer-lbl" style={{ color: danger ? "rgba(239,68,68,.8)" : warn ? "rgba(245,158,11,.75)" : "rgba(129,140,248,.75)" }}>
            Temps restant
          </div>
          <div className={valClass}>{formatTime(timeLeft)}</div>
          {danger && (
            <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 3 }}>
              <div className="hud-timer-dot-crit" />
              <div className="hud-timer-warn-txt">CRITIQUE</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}